module.exports = __webpack_public_path__ + "static/media/hero-image-mobile@3x.5d3fa0d7.jpg";